var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5V6C14.5 5.45 14.05 5 13.5 5H5C4.45 5 4 5.45 4 6V18C4 18.55 4.45 19 5 19H13.5C14.05 19 14.5 18.55 14.5 18V15.5L20 19V5L14.5 8.5Z",
    fill: "#00832D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5V6C14.5 5.45 14.05 5 13.5 5H5C4.45 5 4 5.45 4 6V12H14.5V8.5L20 5V12H14.5Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12V18C4 18.55 4.45 19 5 19H9.25V12H4Z",
    fill: "#FFBA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12V15.5L20 19V12H14.5Z",
    fill: "#0066DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12H9.25V19H13.5C14.05 19 14.5 18.55 14.5 18V12Z",
    fill: "#00832D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12H4V18C4 18.55 4.45 19 5 19H9.25V12Z",
    fill: "#E37400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet);
export default __webpack_public_path__ + "static/media/googleMeet.83a652ef6723fbb0d597e6c774fc13a2.svg";
export { ForwardRef as ReactComponent };